




















import { defineComponent } from '@nuxtjs/composition-api';
import BaseOverlay from '@shared/components/@atoms/BaseOverlay/BaseOverlay.vue';
import UCAppHeaderItem from '@shared/components/@atoms/UCAppHeaderItem/UCAppHeaderItem.vue';

import AppHeaderGrid from './internal/AppHeaderGrid.vue';

export default defineComponent({
  name: 'AppHeader',
  components: { UCAppHeaderItem, BaseOverlay, AppHeaderGrid },
  props: {
    showOverlay: {
      type: Boolean,
      default: false,
    },
  },
});
